/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="./egifts.base.section.ts" />

module Meevo.Plugins.Egifts {
    'use strict';
    
    import IEGiftsSettings = Meevo.Model.IEGiftsSettings;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import MerchantAccount = Meevo.Model.MerchantAccount
    import StorageTypeEnum = Meevo.Model.StorageTypeEnum;
    import IStorageFile = Meevo.Model.IStorageFile;
    import MeevoFile = Meevo.Model.MeevoFile;
    import TimeFormatEnum = Meevo.Model.TimeFormatEnum;
    import MerchantProvider = Meevo.Model.MerchantProvider;
    import EGiftTemplateCatEnum = Meevo.Model.EGiftTemplateCatEnum;
    import MaintenanceFormState = Meevo.Model.MaintenanceFormState
    import IShippingfee = Meevo.Model.IShippingfee;
    import EgiftMultiPurchaseFlow = Meevo.Model.EgiftMultiPurchaseFlow;

    export class MainSection extends EgiftsBaseSection {

        constructor(params: ISectionParamsEgifts,
            protected $q: angular.IQService,
            protected APP_TIME_FORMAT: TimeFormatEnum,
            protected dataForModel: IEGiftsSettings,
            protected modalService: Meevo.Components.Modal.IModalService) {
            super(params);

            this.model = dataForModel;
            this.activate();
        }

        //todo check model interface with enum's
        public stockImages: Array<MeevoFile>;
        public model: IEGiftsSettings;
        public merchantAccounts: Array<MerchantAccount>;
        public modelMerchantAccountIdBackup: string;
        public location: EgiftMainSection.IEgiftLocationItem;
        public eGiftCategories: Array<ICategoryTypesOption> = this.eGiftCategoriesData;
        public urlRegExp = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
        public customBrandingSettings: Meevo.Model.ICustomBranding;
        public imageForTemplatePreview: string;
        public mockForTemplate = {
            price: 150,
            text: 'Happy birthday to my best friend, the one I care about the most!'
        };
        public inStorePickUpHours: Array<number> = [0, 24, 48, 72];
        public enableAutoGenerateGiftCardNumberButton: boolean;
        public timeFormatHours: Array<{ label: string, value: number }> = [];
        public timePeriod: string = '';
        public isSelectLocation: boolean;
        public isFundsSales: boolean;
        public locationToExclude: Array<number> | null;
        public listOfExcludedLocations: Array<any> = [];
        public merchantProviders: Array<MerchantProvider>;
        public barcodeFormats: { code39: string; code128: string} = { code39: 'Code39', code128: 'Code128'};
        public egiftMultiPurchaseFlows: Array<{ label: string, value: number }> = Object.keys(EgiftMultiPurchaseFlow)
            .filter(key => isNaN(Number(key)))
            .map(key => ({
                label: key,
                value: EgiftMultiPurchaseFlow[key as keyof typeof EgiftMultiPurchaseFlow]
            }));
        private locationBackup: EgiftMainSection.IEgiftLocationItem;
        public isSingleLocation: boolean = false;
        public revertValues = {};
        public baseEndpoint = 'eGift/settings';
        public defaultReferralTypeDetail: Model.DataDetail = {};
        public shippingFeeTempValue = null;
        
        preSave(): void {
            //fixing request issue
            if (this.model.termsAndConditions) {
                this.model.termsAndConditions.objectStateEnum = ObjectStateEnum.Active;
            }

            if (this.model.settings.chargeShippingFee && !this.model.shippingFees.length) {
                this.model.settings.chargeShippingFee = false;
            }

            if (this.context.isSingleLocation()) {
                this.model.settings.locationId = this.identityService.locationId;
            } else {
                this.model.settings.locationId = this.location ? this.location.locationId : null;
                this.locationBackup = this.location;
                this.modelMerchantAccountIdBackup = this.model.settings.paymentProcessingPreferences;
            }

            if (!this.context.isCommonLocation) {              
                if (this.model.displayLogoImageObject.meevoFile) {
                    this.saveImage(this.model.displayLogoImageObject);
                }

                this.model.settings.displayLogoOnCardImage = this.model.displayLogoImageObject.fileGuid;
            }

            if (this.model.settings.enableNewEgiftExperience) {
                this.model.settings.selectedLocationWillReceiveFundsFromEgiftSales = this.model.settings.requireClientToSelectLocation;
            }                                
        }

        reloadData(): void {
            this.location = this.locationBackup;

            if (this.model.settings) {
                this.getMerchantAccounts(this.model.settings.locationId);
                /* After each 'Back' button click this method should be started for the rollbacking emailEGiftToRecipientAtXHoursOnActivationDate and timePeriod variables
                 * Rollback starts after this method, so backup should be get manually
                 */
                this.setTimeFormatHours(this.originalEntity.settings.emailEGiftToRecipientAtXHoursOnActivationDate);
                this.defaultReferralTypeDetail = {
                    displayName: this.model.settings.egiftDefaultReferralTypeDisplayName,
                    id: this.model.settings.egiftDefaultReferralTypeId
                };
            }
        }

        public getMerchantAccounts(locationId?: number): void {
            if (locationId === undefined) {
                this.merchantAccounts = [];
                this.model.settings.paymentProcessingPreferences = null;
                return;
            }

            const request: EgiftMainSection.IGetMerchantAccountsReq = {
                criteria: {
                    coSearchType: 0,
                    coFilterByLocationId: locationId
                }
            };

            this.egiftsService.getMerchantAccounts(request)
                .then((merchantAccounts: Array<MerchantAccount>) => {
                    this.merchantAccounts = this.egiftsService.merchantAccountPreProcess(merchantAccounts, this.merchantProviders);
                    if (this.model.settings.paymentProcessingPreferences == null) {
                        this.egiftsService.getBusinessSettings().then(data => {
                            this.model.settings.egiftDisplayCode = data.generalSettings.useCode128Barcodes ? this.barcodeFormats.code128 : this.barcodeFormats.code39;
                        });
                    }

                    if (!this.merchantAccounts.map(merchantAccount => merchantAccount.id === this.modelMerchantAccountIdBackup).length) {
                        this.model.settings.paymentProcessingPreferences = null;
                    } else {
                        this.model.settings.paymentProcessingPreferences = this.modelMerchantAccountIdBackup;
                    }
                });
        }

        public getLocation(locationId: number): void {
            const request: EgiftMainSection.IGetLocationReq = {
                criteria: {
                    filterBySessionUser: true
                }
            };

            this.egiftsService.getLocation(locationId)
                .then((response: EgiftMainSection.IEgiftLocationItem) => this.locationBackup = this.location = response)
                .finally(() => this.busyService.stop());
        }

        getEgiftsImage(fileGuid: Guid) {
            return this.getImageUrl(StorageTypeEnum.CustomBrandingLogoImage, fileGuid)
                .then(response => {
                    if (response) {
                        this.model.displayLogoImageObject = response;
                    }

                    return this.getTemplate();
                })
        }

        getCustomBrandingImage() {
            return this.egiftsService.getCustomBrandingImage()
                .then(response => {
                    this.customBrandingSettings = response;

                    if (!response.pageDisplayLogoImage) {
                        let defer = this.$q.defer();

                        this.getTemplate();
                        this.model.displayLogoImageObject = {};
                        defer.resolve({});
                        return defer.promise;
                    }

                    return this.getEgiftsImage(response.pageDisplayLogoImage)
                })
                .then(response => {
                    this.model.displayLogoImageObject.fileGuid = null;

                    if (this.model.displayLogoImageObject.meevoFile) { //todo: not sure about this if
                        this.model.displayLogoImageObject.meevoFile.fileGuid = null;
                    }

                    return response;
                });
        }

        public activate(): void {
            super.activate();

            this.busyService.start();
            this.model.eGiftTemplatePreview = [];
            this.enableAutoGenerateGiftCardNumberButton = this.model.enableAutoGenerateGiftCardNumberButton;
            this.defaultReferralTypeDetail = {
                displayName: this.model.settings.egiftDefaultReferralTypeDisplayName,
                id: this.model.settings.egiftDefaultReferralTypeId
            };

            if (!this.context.isCommonLocation) {
                const promMy = (this.model.settings && this.model.settings.displayLogoOnCardImage) ?  this.getEgiftsImage(this.model.settings.displayLogoOnCardImage) : this.getCustomBrandingImage();

                if (this.model.settings) {
                    this.setTimeFormatHours(this.model.settings.emailEGiftToRecipientAtXHoursOnActivationDate);
                }

                this.setExcludedList(this.model.excludeLocationIds);
                this.getMerchantProviders();

                promMy.finally(() => {
                    this.busyService.stop();
                });
            }

            this.isSingleLocation = this.context.isSingleLocation();
            this.shippingFessPositionAssignSort();
        }

        setTimeFormatHours(settingTime: number): void {
            if (this.APP_TIME_FORMAT === TimeFormatEnum.TimeFormat24) {
                // Generate 24-hour format options (01:00 - 00:00)
                this.timeFormatHours = [];
                for (let i = 1; i <= 24; i++) {
                    var hour = i < 10 ? '0' + i : i.toString();
                    this.timeFormatHours.push({
                        label: i === 24 ? '00:00' : `${hour}:00`,
                        value: i
                    });
                }
            } else {
                // Generate 24-hour format options (1-12)
                this.timePeriod = settingTime > 12 ? 'PM' : 'AM';

                this.prepopulateTimeFor12Hours();
            }
        }

        periodChange(): void {
            //on change pm/am or visa versa
            this.prepopulateTimeFor12Hours();

            this.model.settings.emailEGiftToRecipientAtXHoursOnActivationDate =
                this.timePeriod === 'AM' ? this.model.settings.emailEGiftToRecipientAtXHoursOnActivationDate - 12 : this.model.settings.emailEGiftToRecipientAtXHoursOnActivationDate + 12;
        }

        prepopulateTimeFor12Hours(): void {
            this.timeFormatHours = [];
            const timeValueFunction = this.timePeriod === 'AM' ? (i) => i : (i) => i + 12;

            for (let i = 1; i <= 12; i++) {
                this.timeFormatHours.push({
                    label: `${i}`,
                    value: timeValueFunction(i)
                });
            }
        }

        setExcludedList(locationToExclude: Array<number>): void {
            for (let key in locationToExclude) {
                this.listOfExcludedLocations.push({id: key, storeName: locationToExclude[key]})
            }
        }

        isShowLocationFields(): boolean {
            return !this.model.settings.requireClientToSelectLocation || (!this.model.settings.enableNewEgiftExperience && !this.model.settings.selectedLocationWillReceiveFundsFromEgiftSales);
        }

        clearLocationAndMerchant(): void {
            [this.location, this.model.settings.paymentProcessingPreferences] = [null,null]
        }

        setDataWeeksNumberCO(): void {

            const propertyToFind = ['EgiftExpirationDaysNumber', 'FreeEgiftExpirationDaysNumber'];

            this.model.settings.settings.forEach((item, i, arr) => {
                if (_.contains(propertyToFind, item.displayName)) {
                    this.revertValues[item.displayName] = item.metadata.tenantValue === undefined ? item.metadata.systemValue : Math.round(item.metadata.tenantValue / 7);}
            });

        }

        checkForEqualCO(key: string, baseValue: number): boolean {
            return this.revertValues[key] == baseValue;
        }

        // edit function list
        preEdit(): void {
            super.takeBackup();
            if (!this.context.isApplicationModeCO()) this.setDataWeeksNumberCO();
            else return
        }

        enableChargeShippingFee() {
            if (this.model.settings.mailEnable) {
                this.model.settings.chargeShippingFee = true
            }
        }

        cancel() {
            super.rollbackChanges();
        }

        switchFees(currentIndex: number, moveIndex: number, shippingfees: IShippingfee[]) {
            shippingfees = this.model.shippingFees;

            shippingfees.forEach((f, i) => f.position = i)

            if (shippingfees[currentIndex] && shippingfees[moveIndex]) {
                const temp = shippingfees[moveIndex];
                shippingfees[moveIndex] = shippingfees[currentIndex];
                shippingfees[currentIndex] = temp;

                shippingfees[moveIndex].position = moveIndex;
                shippingfees[currentIndex].position = currentIndex;
            }
        }

        shippingFessPositionAssignSort() {
            let lastIndex = 0;
            let tempArrWithOutPosition = [];
            let tempArrWithPosition = [];

            if (!this.model.shippingFees || !this.model.shippingFees.length) return;

            this.model.shippingFees.forEach(fee => {
                if (fee.position || fee.position === 0) {
                    tempArrWithPosition.push(fee);
                } else {
                    tempArrWithOutPosition.push(fee);
                }
            })
            tempArrWithPosition.sort((a, b) => a.position - b.position);
            lastIndex = tempArrWithPosition.length - 1;

            tempArrWithOutPosition.forEach(fee => {fee.position = lastIndex + 1;lastIndex++;})
            this.model.shippingFees = [...tempArrWithPosition, ...tempArrWithOutPosition];
        }

        /**
         * get template image object
         * @returns angular.IPromise<Array<any>>
         */
        private getTemplate(): angular.IPromise<ITemplateItem> {
            return this.egiftsService.getTemplateList()
                .then(response => {
                    if(response && response[0]) {
                        this.model.eGiftTemplatePreview = response[0];
                    }

                    return response;
                });
        }

        /**
         * Save image file
         * @param {IStorageFile} file
         * @returns void
         */
        private saveImage(file: IStorageFile): void {
            this.busyService.start();
            this.saveImageToStorage(file)
                .then((response: Array<IStorageFile | any>) => {})
                .catch(error => {
                    this.loggingService.trace(error.statusText);
                })
                .finally(() => {
                    this.busyService.stop();
                });
        }

        /**
         * Get image url
         * @param {StorageTypeEnum} storageTypeEnum
         * @param {Guid} fileGuid
         * @returns angular.IPromise<any>
         */
        private getImageUrl(storageTypeEnum: StorageTypeEnum, fileGuid: Guid): angular.IPromise<ITemplateItem> {
            return this.egiftsService.getImageUrl(storageTypeEnum, fileGuid);
        }

        /**
         * Get merchant providers for merchant account's preprocessing
         */
        private getMerchantProviders(): void {
            this.egiftsService.getMerchantProviders().then((merchantProviders: Array<MerchantProvider>) => this.merchantProviders = merchantProviders)
        }

        /**
         * Save image to storage
         * @param {IStorageFile} file
         * @returns {angular.IPromise}
         */
        public saveImageToStorage(file: IStorageFile): angular.IPromise<any> {
            if (!Object.keys(file).length) {
                return this.$q.resolve({});
            }

            return this.egiftsService.saveImageToStorage(file);
        }

        public updateDefaultReferralType(): void {
            this.model.settings.egiftDefaultReferralTypeId = this.defaultReferralTypeDetail ? this.defaultReferralTypeDetail.id : null;
            this.model.settings.egiftDefaultReferralTypeDisplayName = this.defaultReferralTypeDetail ? this.defaultReferralTypeDetail.displayName : null;
        }

        public shippingFeeModalAlert() {
            if (this.model.shippingFees.length || !this.model.settings.chargeShippingFee) return;

            this.modalService.alert('LABEL_NO_SHIPPING_FEE_OPTIONS_MODAL_NOTE', Meevo.Components.Modal.ModalTranslationModes.Translate)
        }

        get egiftUrl() {
            return this.model.egiftUrl;
        }

        get egiftNewUrl() {
            return this.model.egiftNewUrl;
        }

        get storageTypeEnum() {
            return StorageTypeEnum;
        }

        get templateImage() {
            return this.model.displayLogoImageObject.meevoFile.files[0].fileUrl
        }

        get processingFeeTypeEnum() {
            return ProcessingFeeTypeEnum;
        }

        get expirationWeeksNumberMinValue() {
            return (this.model.settings && this.model.settings.mailEnable) ? Math.ceil(this.model.settings.shippingAndHandlingDays / 7) : 0;
        }

        get egiftExpirationWeeksNumber(): number {
            if (!this.model.settings) return;

            return Math.round(this.model.settings.egiftExpirationDaysNumber / 7);
        }

        get freeEgiftExpirationWeeksNumber(): number {
            if (!this.model.settings) return;

            return Math.round(this.model.settings.freeEgiftExpirationDaysNumber / 7);
        }

        get getTimeFormatEnum() {
            return TimeFormatEnum;
        }

        get maintenanceFormState() {
            return MaintenanceFormState;
        }

        set egiftExpirationWeeksNumber(weeks: number) {
            if (!this.model.settings) return;

            this.model.settings.egiftExpirationDaysNumber = weeks * 7;
        }

        set freeEgiftExpirationWeeksNumber(weeks: number) {
            if (!this.model.settings) return;

            this.model.settings.freeEgiftExpirationDaysNumber = weeks * 7;
        }

        ////Main Data////

        get eGiftCategoriesData(): Array<ICategoryTypesOption> {
            return [
                //{
                //    label: "LABEL_EGIFT_ALL_OCCASION",
                //     value: EGiftTemplateCatEnum.AllOccasion
                //},
                {
                    label: "LABEL_ANNIVERSARY",
                    value: EGiftTemplateCatEnum.Anniversary
                },
                {
                    label: "LABEL_EGIFT_ANY_OCCASION",
                    value: EGiftTemplateCatEnum.AnyOccasion
                },
                {
                    label: "LABEL_EGIFT_BABY_SHOWER",
                    value: EGiftTemplateCatEnum.BabyShower
                },
                {
                    label: "LABEL_EGIFT_BIRTHDAY",
                    value: EGiftTemplateCatEnum.Birthday
                },
                {
                    label: "LABEL_EGIFT_CONGRATULATIONS",
                    value: EGiftTemplateCatEnum.Congratulations
                },
                {
                    label: "LABEL_EGIFT_FATHERS_DAY",
                    value: EGiftTemplateCatEnum.FathersDay
                },
                {
                    label: "LABEL_EGIFT_HOLIDAY",
                    value: EGiftTemplateCatEnum.Holiday
                },
                {
                    label: "LABEL_EGIFT_MOTHERS_DAY",
                    value: EGiftTemplateCatEnum.MothersDay
                },
                {
                    label: "LABEL_EGIFT_THANK_YOU",
                    value: EGiftTemplateCatEnum.ThankYou
                },
                {
                    label: "LABEL_EGIFT_VALENTINE",
                    value: EGiftTemplateCatEnum.Valentine
                },
                {
                    label: "LABEL_EGIFT_WEDDING",
                    value: EGiftTemplateCatEnum.Wedding
                }
            ];
        }

        get defaultChargeShipping(): IChargeShipping {
            return { chargeSelected: true, displayName: '', value: null };
        }
    }
}
